import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_38_95_1W_5_54',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_38_95_1w_5_54_usd',
		},
		primer: 'prd_FIDldFd2Nzzs',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 5.54,
		},
		originalPriceMap: {
			USD: 17.77,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 38.95,
		},
	},
}
